export default __webpack_public_path__ + "static/media/ArrowUp.8a39cfce.svg";